/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetPouchStatusTotalParams,
  GetPouchTypeTotalsResponseResponse,
  NoContentResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get sum of all pouches amount for cash.stock,forex in status wise in V000000000 if no status passed default-prepared status sum
 * @summary Get Total pouches amount for cash.stock,forex in status wise in V000000000 (default-prepared status)
 */
export const getPouchStatusTotal = (params?: GetPouchStatusTotalParams, signal?: AbortSignal) => {
  return customInstance<GetPouchTypeTotalsResponseResponse | NoContentResponse>({
    url: `/bm-pouch-management/v1/pouch/status/total`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetPouchStatusTotalQueryKey = (params?: GetPouchStatusTotalParams) => {
  return [`/bm-pouch-management/v1/pouch/status/total`, ...(params ? [params] : [])] as const;
};

export const getGetPouchStatusTotalQueryOptions = <
  TData = Awaited<ReturnType<typeof getPouchStatusTotal>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  params?: GetPouchStatusTotalParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPouchStatusTotal>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPouchStatusTotalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPouchStatusTotal>>> = ({ signal }) =>
    getPouchStatusTotal(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPouchStatusTotal>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPouchStatusTotalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPouchStatusTotal>>
>;
export type GetPouchStatusTotalQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Get Total pouches amount for cash.stock,forex in status wise in V000000000 (default-prepared status)
 */
export const useGetPouchStatusTotal = <
  TData = Awaited<ReturnType<typeof getPouchStatusTotal>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  params?: GetPouchStatusTotalParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPouchStatusTotal>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPouchStatusTotalQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
